import { AttentionWorker } from "./workers/attentionWorker";
import { OUTPUT_CONSOLE_VERSION } from "./utils/outputConsoleVersion";
import { WEB_PUSH_NOTIFICATION_SERVICE } from "./push-notification/subscribe";
import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import BootstrapVue from "bootstrap-vue";
import VeeValidate from "vee-validate";
import VuejsDialog from "vuejs-dialog";
import VueChatScroll from "vue-chat-scroll";
import Toasted from "vue-toasted";
import wysiwyg from "vue-wysiwyg";
import Datetime from "vue-datetime";
import App from "./App";
import router from "./router";
import store from "./store";
import VueExcelXlsx from "vue-excel-xlsx";
import "./utils/filters";
import { sync } from "vuex-router-sync";
import { i18n } from "./language";
import messagesTR from "./language/validationMessagesTR";
import messagesEN from "./language/validationMessagesEN";
import messagesRU from "./language/validationMessagesRU";
import messagesDE from "./language/validationMessagesDE";
import messagesFR from "./language/validationMessagesFR";
import messagesES from "./language/validationMessagesES";
import messagesAR from "./language/validationMessagesAR";
import messagesIT from "./language/validationMessagesIT";
import CKEditor from "@ckeditor/ckeditor5-vue";
import { garbageChatCollector } from "./workers/garbageChatCollector";
import { liveVisitorsSyncWorker } from "./workers/liveVisitorsSyncWorker";
import { conversationsSyncWorker } from "./workers/conversationsSyncWorker";
import { startTitleUpdater } from "./workers/titleUpdater";
import { liveVisitorCountReporter } from "./workers/liveVisitorCountReporter";
import { log2 } from "./utils/log2";
import rate from "vue-rate";
import "vue-rate/dist/vue-rate.css";
import vuescroll from "vuescroll";
import VueECharts from "vue-echarts";
import VueContextMenu from "@xunlei/vue-context-menu";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import "./assets/css/vue-easytable/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library
import VCalendar from "v-calendar";

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: "vc",
});
//#region  charts
import ECharts from "vue-echarts";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { LMap, LMarker, LTileLayer } from "vue2-leaflet";
import { mask as maskDirective } from "vue-the-mask";
import "leaflet/dist/leaflet.css";
import _ from "lodash";
import moment from "moment";
import { startUserPermissionValidator } from "./workers/userPermissionValidator";
import VueAudioVisual from "vue2-audio-visual";
import { quillEditor } from "vue-quill-editor";
import VueTyperPlugin from "vue-typer";

import gifPlayer from "vue-gifplayer";
import "vue-gifplayer/src/gif.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

require("./utils/session");
require("./api/hostFetcher");
require("./push-notification/windowPubSub");
require("./components/svg/icons/registerIcons");

console.log(
    "%c " + OUTPUT_CONSOLE_VERSION,
    "font-weight: bold; font-size: 50px;color: orange; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)"
);

Vue.component("v-chart", ECharts);
//#endregion

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("v-chart", VueECharts);
Vue.component("quill-editor", quillEditor);
Vue.use(gifPlayer);

const log = log2("main");
sync(store, router);
log.info("process.env", process.env);
Vue.use(Datetime);
Vue.use(wysiwyg, {
    hideModules: { image: true },
});
Vue.use(CKEditor);
Vue.use(VueChatScroll);
Vue.use(VuejsDialog);
Vue.use(Toasted);
Vue.use(VueExcelXlsx);
Vue.use(vuescroll);
Vue.use(VueECharts);
Vue.use(VueAudioVisual);
Vue.use(VueContextMenu);
Vue.use(VueTyperPlugin);
Vue.use(VueEasytable);
Vue.use(Toast, {
    transition: "Vue-Toastification__fade",
    maxToasts: 20,
    newestOnTop: true,
});
Vue.directive("mask", (e, b) => {
    if (!b.value) {
        return;
    }
    maskDirective(e, b);
});
Vue.config.productionTip = false;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VeeValidate, {
    locale: "tr",
    fieldsBagName: "veeFields",
    dictionary: {
        tr: { messages: messagesTR.messages },
        en: { messages: messagesEN.messages },
        ru: { messages: messagesRU.messages },
        de: { messages: messagesDE.messages },
        fr: { messages: messagesFR.messages },
        es: { messages: messagesES.messages },
        ar: { messages: messagesAR.messages },
        it: { messages: messagesIT.messages },
    },
});
Vue.use(BootstrapVue);

Vue.use(rate);
new Vue({
    el: "#app",
    router,
    i18n,
    store,
    render: (h) => h(App),
});
garbageChatCollector();
liveVisitorsSyncWorker();
conversationsSyncWorker();
liveVisitorCountReporter();
startTitleUpdater();
startUserPermissionValidator();

Object.defineProperty(Vue.prototype, "$_", { value: _ });
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
const isEnabledSite = () => {
    const enabledSites = [
        "supsis.live",
        "beta.supsis.live",
        "betnano.supsis.live",
        "truvabet.supsis.live",
        "missafir.supsis.live",
        "metaecu.supsis.live",
    ];
    const randomEnabledSite = Math.ceil(Math.random() * 100) % 10 === 0;
    return enabledSites.includes(window.location.hostname) || randomEnabledSite;
};
if (isEnabledSite()) {
    const SENTRY_REPLAY_ENABLED =
        ["supsis.live", "betnano.supsis.live", "truvabet.supsis.live"].includes(window.location.hostname) &&
        Math.ceil(Math.random() * 100) < 50;
    Sentry.init({
        Vue,
        dsn: "https://3625853a8bcb4edf9bd7d1226129e1e5@o1039697.ingest.sentry.io/6109915",
        integrations: [
            !!localStorage.getItem("sentry-disable-global-handler")
                ? new Sentry.Integrations.GlobalHandlers({
                      onerror: false,
                      onunhandledrejection: false,
                  })
                : undefined,
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: [
                    "localhost",
                    "*.supsis.live",
                    "api.supsis.live",
                    "beta-api.supsis.live",
                    "socket.supsis.live",
                    "beta-socket.supsis.live",
                    "tablet-api-local.supsis.live/",
                ],
            }),
            SENTRY_REPLAY_ENABLED
                ? new Sentry.Replay({
                      maskAllText: false,
                      blockAllMedia: false,
                  })
                : undefined,
        ].filter(Boolean),
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        environment: process.env.ENVIRONMENT,
        enabled: isEnabledSite(),
        beforeSend: (event, hint) => {
            // do not send if error is "Axios Error"
            const errors = _.get(event, "exception.values", []) || [];
            const isAxiosIncludes = errors.some((error) => {
                const isAxios = (error.value || "").toLowerCase().includes("axios");
                const isNetwork = (error.value || "").toLowerCase().includes("network");
                const isTimeout = (error.value || "").toLowerCase().includes("timeout");
                return !isTimeout && (isNetwork || isAxios);
            });
            if (isAxiosIncludes) {
                return null;
            }
            return event;
        },
        logErrors: true,
        release: require("../package.json").version,
        ignoreTransactions: false,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.5,
    });
    window.Sentry = Sentry;
}

WEB_PUSH_NOTIFICATION_SERVICE.registerServiceWorker();

// AttentionWorker.start();
